import React, { useEffect } from 'react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)
ScrollTrigger.defaults({})

function CsrManagement({
  title,
  para1,
  para2,
  image,
  hideList,
  extras,
  imageAlign = 'left',
}: {
  title: JSX.Element
  para1: JSX.Element
  para2?: JSX.Element
  image: string
  hideList?: boolean
  extras?: JSX.Element
  imageAlign?: 'left' | 'right'
}) {
  useEffect(() => {
    const ctx = gsap.context(() => {
      if (!hideList) {
        gsap.fromTo(
          '.paragraph-container',
          { opacity: 0, scale: 0.95 },
          {
            opacity: 1,
            scale: 1,
            duration: 1.2,
            ease: 'power3.out',
            scrollTrigger: {
              trigger: '.paragraph-container',
              start: 'top 85%',
            },
          },
        )
      }
    })
    return () => ctx.revert()
  }, [hideList])

  return (
    <section>
      <section className="md:grid grid-cols-2 md:gap-10 2xl:gap-20">
        {imageAlign === 'right' && (
          <div className="flex pt-10 md:p-0 sm:max-w-md sm:mx-auto lg:max-w-none">
            <img
              src={image}
              alt="CSR"
              className="rounded-[15%] shadow-[7px_7px_0px_0px_#e8ba3a]"
            />
          </div>
        )}

        <article className="paragraph-container">
          <div className="lg:max-w-2xl">
            <h2 className="text-green font-semibold text-3xl pb-6">
              {title}
            </h2>

            <div className="space-y-4 xl:text-lg">{para1}</div>

            {para2 && (
              <div className="mt-4 xl:text-lg">{para2}</div>
            )}

            {extras && <div className="mt-6 xl:text-lg">{extras}</div>}
          </div>
        </article>

        {imageAlign === 'left' && (
          <div className="flex pt-10 md:p-0 sm:max-w-md sm:mx-auto lg:max-w-none">
            <img
              src={image}
              alt="CSR"
              className="rounded-[15%] shadow-[7px_7px_0px_0px_#e8ba3a]"
            />
          </div>
        )}
      </section>
    </section>
  )
}

export default CsrManagement
